import React from "react";
import { Breadcrumbs } from "./Breadcrumbs";
import { UspBar } from "./UspBar";
import SafeSiteSeo from "./SafeSiteSeo";
import { SubscribeToNewsletter } from "./SubscribeToNewsletter";
import { graphql, useStaticQuery } from "gatsby";

export default function PageLayout({
  title,
  seo,
  seoSchema,
  breadcrumbs,
  children,
  disableSubscribeToNewsletter = false
}) {
  const {
    wp: { siteSettings }
  } = useStaticQuery(graphql`
    query GlobalSubscribeToNewsletterQuery {
      wp {
        siteSettings {
          siteSettings {
            subscribeToNewsletterBackground
            subscribeToNewsletterTitle
            subscribeToNewsletterSubText
            subscribeToNewsletterDisclaimer
            subscribeToNewsletterConfirmation
            subscribeToNewsletterIcon {
              mediaItemUrl
            }
            subscribeToNewsletterImage {
              mediaItemUrl
            }
            enableSubscribeToNewsletterComponent
          }
        }
      }
    }
  `);

  return (
    <>
      <SafeSiteSeo post={seo} postSchema={seoSchema} title={title} />
      <UspBar />
      {breadcrumbs && breadcrumbs.length > 1 ? (
        <Breadcrumbs breadcrumbs={breadcrumbs} />
      ) : (
        ""
      )}
      {children}
      {disableSubscribeToNewsletter || !siteSettings.siteSettings.enableSubscribeToNewsletterComponent ? ("") : (
        <SubscribeToNewsletter
          background={siteSettings.siteSettings.subscribeToNewsletterBackground}
          title={siteSettings.siteSettings.subscribeToNewsletterTitle}
          subText={siteSettings.siteSettings.subscribeToNewsletterSubText}
          disclaimer={siteSettings.siteSettings.subscribeToNewsletterDisclaimer}
          confirmation={siteSettings.siteSettings.subscribeToNewsletterConfirmation}
          icon={siteSettings.siteSettings.subscribeToNewsletterIcon}
          image={siteSettings.siteSettings.subscribeToNewsletterImage}
        />
      )}
    </>
  );
}
